module.exports = __webpack_public_path__ + "img/web-hosting.cb0f426.svg";